import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
  order?: string;
}

const ENDPOINTS = {
  getUserTrustedDevices: (userUuid: string, query: QueryProps) =>
    `/user/${userUuid}/devices/?${objToQueryString(query)}`,
  deleteTrustedDevices: (userUuid: string) =>
    `/user/${userUuid}/devices/disable/`,
};

export default ENDPOINTS;
